import {  } from "../../../types/Classroom";
import { PagedRequestType, PagedResultsType } from "../../../types/PagedResults";
import { VacancyType } from "../../../types/Vacancy";
import { get, post, put } from "../../../utils/axios-config";
import { VACANCIES } from "../../../utils/constants";

export const createVacancy= async (data: VacancyType) => await post<VacancyType, string>(VACANCIES, data);
export const updateVacancy= async (data: VacancyType) => await put<VacancyType, string>(VACANCIES, data);
export const getVacancies = async (data?: PagedRequestType) => {
    const queryParams = new URLSearchParams({
        PageNumber: data?.PageNumber?.toString() || '1',
        PageSize: data?.PageSize?.toString() || '100',
        ...(data?.IdFaculty ? { IdFaculty: data.IdFaculty } : {}),
        ...(data?.IdDepartament ? { IdDepartament: data.IdDepartament } : {}),
        ...(data?.IdCourse ? { IdCourse: data.IdCourse } : {}),
    });
    const url = `${VACANCIES}?${queryParams.toString()}`;
    return await get<PagedResultsType<VacancyType>>(url)
};